module.exports = __webpack_public_path__ + "img/canada-external-causes-female.a32f0f10.png";